export const MUTATION_SET_DATA_COLLECTION = 'MUTATION_SET_DATA_COLLECTION';
export const MUTATION_SET_DATA_ITEM = 'MUTATION_SET_DATA_ITEM';
export const MUTATION_SET_CONTENT_LOADING_STATUS = 'MUTATION_SET_CONTENT_LOADING_STATUS';

export const MUTATION_SET_TABLE_ITEMS = 'MUTATION_SET_TABLE_ITEMS';
export const MUTATION_ADD_TABLE_ITEMS = 'MUTATION_ADD_TABLE_ITEMS';
export const MUTATION_REMOVE_TABLE_ITEMS = 'MUTATION_REMOVE_TABLE_ITEMS';
